import axiosInstance from 'ns_libs/nsAxios';
import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS from 'services/urls';
import { IProFormaData } from 'views/ProFormaTable/types';

interface IProFormaProps {
    dealId: number;
    proFormaId: number;
}

const getProForma = async ({ dealId, proFormaId }: IProFormaProps): Promise<IProFormaData> => {
    const response = await axiosInstance.get(API_ENDPOINTS.PRO_FORMA(dealId, proFormaId));
    return response.data;
};

const useGetProForma = (dealId: number, proFormaId: number, options?: any) => useQuery<IProFormaData>({
    queryKey: ['proFormaData', dealId, proFormaId],
    queryFn: () => getProForma({ dealId, proFormaId }),
    ...options,
});

export default useGetProForma;
